export const colorsVars = {
  white: '#fff',
  black: '#000',
  white20: '#ffffff33',
  neutral100: '#fff',
  neutral200: '#FBFBF8',
  neutral300: '#F6F4EE',
  neutral400: '#F4EDE3',
  neutral500: '#DBD5CC',
  neutral600: '#8F8B85',
  primary100: '#1962C7',
  primary200: '#103C7A',
  primary300: '#092347',
  primary400: '#06172E',
  yellow: '#DDFF00'
}
